import { Trigger } from '@radix-ui/react-dropdown-menu'

import { styled } from '~/styled'

export const DropdownMenuTrigger = styled(Trigger, {
  base: ['disabled:cursor-not-allowed', 'disabled:opacity-30']
})
